export default "__VITE_ASSET__T9UCn$bS__"